import React from 'react';
import {FieldArray} from 'react-final-form-arrays';

import Button from "components/Button/Button";
import MembersFiltersField from './Members.Filters.Field';
import Styled from './styled/StyledMember.Filters';
import {FormattedMessage} from "react-intl";

const MembersFiltersFields = ({name, filters, form}) => {
  return (
    <FieldArray name={name}>
      {({fields}) => (
        <Styled.MembersFiltersFields>
          <Button uitype='addFilters' onClick={() => fields.push({})}>
            <FormattedMessage id="Members.AddFilter"/>
          </Button>

          {fields.map((field, index) => (
            <MembersFiltersField
              remove={fields.remove}
              index={index}
              field={field}
              filters={filters}
              key={field}
              form={form}
            />
          ))}
        </Styled.MembersFiltersFields>
      )}
    </FieldArray>
  );
};

export default MembersFiltersFields;
